import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Broken({
  color = 'status.blue',
  strokeWidth = '1',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 11 10' {...props}>
      <Path
        d='M5.60547 3.21875H7.55834C8.90602 3.21875 9.99943 4.29171 9.99943 5.61572C9.99943
           6.93905 8.90672 8.0127 7.55834 8.0127H5.60547'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1.50273 2.99951L2.48342 3.47613'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.5541 1.11012L3.95033 2.2579'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1.29297 5.73828L2.38262 5.37838'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Broken.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Broken
